import { createAction } from 'redux-actions'

export const setVehicleDetails = createAction('CONFIRM_TIRE_SIZE/SET_VEHICLE_DETAILS')
export const setVehicleTireSizes = createAction('CONFIRM_TIRE_SIZE/SET_VEHICLE_TIRE_SIZES')
export const loadConfirmTireSizeData = createAction('CONFIRM_TIRE_SIZE/LOAD_DATA')
export const cleanConfirmTireSizeData = createAction('CONFIRM_TIRE_SIZE/CLEAN_DATA')
export const setExtraVehicleDetails = createAction('CONFIRM_TIRE_SIZE/SET_EXTRA_VEHICLE_DETAILS')
